import { useState, useEffect } from 'react';

/**
 * Debounce hook - delays updating the value until after the specified delay
 * Perfect for search inputs to reduce re-renders and API calls
 * 
 * @param value - The value to debounce
 * @param delay - Delay in milliseconds (default: 200ms for snappy UX)
 * @returns The debounced value
 */
export function useDebounce<T>(value: T, delay: number = 200): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
